import React, { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import { getMonths } from "../../helpers";
import { getTotalSuccessRate } from "../../../queries/metrics";
import useLogout from "../../common/useLogout";
import { updateObjectInArray } from "../../../redux/reducers/helpers";
import isEmpty from "lodash/isEmpty";

const chartDataset = JSON.stringify({
  labels: getMonths(),
  datasets: [
    {
      label: "Organization growth",
      data: [],
      fill: false,
      backgroundColor: "#caeed9",
      borderColor: "#caeed9",
      lineTension: 0.1,
    },
  ],
});

const options = {
  legend: {
    display: false,
    position: "bottom",
  },
  tooltips: {
    intersect: false,
    xPadding: 15,
    yPadding: 15,
    callbacks: {
      label: (item) => ` Error rate ${100 - item.yLabel}%`,
    },
  },
  scales: {
    xAxes: [
      {
        gridLines: {
          display: false,
        },
        ticks: {
          maxRotation: 0,
          padding: 5,
        },
      },
    ],
    yAxes: [
      {
        gridLines: {
          drawBorder: false,
          zeroLineColor: "rgba(0,0,0,.5)",
        },
        ticks: {
          beginAtZero: true,
          maxTicksLimit: 6,
          padding: 15,
          callback: function (val) {
            return val + "%";
          },
        },
      },
    ],
  },
};

const SuccessRateBarChart = ({ cableApp, service }) => {
  const [handleLogout] = useLogout();
  const [dataset, setDataset] = useState(JSON.parse(chartDataset));

  const createDataset = (data) => {
    const message = data.message[0];
    dataset.datasets[0].data = message.datapoints;
    setDataset({
      ...dataset,
      datasets: updateObjectInArray(
        dataset.datasets,
        dataset.datasets[0],
        "label"
      ),
    });
  };

  const handleEmptyDataSet = () => {
    setDataset(JSON.parse(chartDataset));
  };

  useEffect(() => {
    cableApp["dashboard-success-rate"] = cableApp.cable.subscriptions.create(
      {
        channel: "ChartsChannel",
        chart_resource: "application-success-rate-dashboard",
      },
      {
        connected: () => {
          getTotalSuccessRate({
            service_name: service.id,
            chart_resource: "application-success-rate-dashboard",
          });
        },
        received: (data) => {
          if (!isEmpty(data.message[0])) {
            createDataset(data);
          } else {
            handleEmptyDataSet();
          }
        },
        rejected: () => {
          handleLogout();
        },
      }
    );
    return () => {
      cableApp["dashboard-success-rate"].unsubscribe();
    };
  }, [service]);

  return <Bar data={dataset} options={options} />;
};

SuccessRateBarChart.propTypes = {};

export default SuccessRateBarChart;
